module.exports = __webpack_public_path__ + "media/img/logos/lidl-cb5274391db553be5b0ef48b34597d68.svg";